import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import Table, {
  DeleteButtonTableCell,
  EditButtonTableCell,
} from '@ts-core/components/Table';

const LessonsTable = (props) => {
  const intl = useIntl();
  const { lessons, loading, error, onEditLesson, onDeleteLesson } = props;

  const getActionsCell = useCallback(
    (_value, _, lesson) => {
      return (
        <Box display="flex" justifyContent="flex-end">
          <EditButtonTableCell item={lesson} onClick={onEditLesson} />
          <DeleteButtonTableCell
            message={intl.formatMessage(
              {
                id: 'dialog.confirmRemoveItem.title',
              },
              { item: lesson.name }
            )}
            item={lesson}
            onConfirm={onDeleteLesson}
          />
        </Box>
      );
    },
    [intl, onEditLesson, onDeleteLesson]
  );

  const columns = useMemo(
    () => [
      {
        Header: 'Clase',
        accessor: 'name',
      },
      { Header: '', accessor: '_id', valueTransformer: getActionsCell },
    ],
    [getActionsCell]
  );
  return (
    <Table
      data={lessons}
      columns={columns}
      loading={loading}
      errorMessage={error}
    />
  );
};

LessonsTable.propTypes = {
  lessons: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.string,

  onEditLesson: PropTypes.func,
  onDeleteLesson: PropTypes.func,
};

LessonsTable.defaultProps = {
  lessons: [],
  loading: false,
  error: undefined,

  onEditLesson: undefined,
  onDeleteLesson: undefined,
};

export default LessonsTable;
